import type {Worker} from "@mytour/shared";
import {useState} from "react";
import {Button} from "reactstrap";
import {WorkerForm} from "../form/WorkerForm.js";

interface EditWorkerActionProps {
  worker: Worker;
}

export function EditWorkerAction({worker}: EditWorkerActionProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <Button size="sm" color="primary" outline onClick={() => setIsFormOpen(true)}>
        Modifier
      </Button>

      {isFormOpen && (
        <WorkerForm isOpen={isFormOpen} worker={worker} onClose={() => setIsFormOpen(false)} />
      )}
    </>
  );
}
